import { RouteRootInterface } from '.';
import DashboardLayout from '../Components/Layouts/Dashboard/Dashboard';
import WorldMap from './WorldMap/WorldMap';
import Callback from './Callback/Callback';
import { lazy } from 'react';
const NotFoundLayout = lazy(
  () => import('@src/Components/Layouts/404Layout/NotFoundLayout')
);

const routes: RouteRootInterface[] = [
  {
    name: 'main',
    path: '/',
    component: DashboardLayout,
    routes: [
      {
        name: 'home',
        path: '/',
        component: WorldMap
      }
    ]
  },
  {
    name: 'callback',
    path: '/callback',
    component: Callback
  },
  {
    name: '404',
    path: '*',
    component: NotFoundLayout
  }
];

export default routes;
